<template>
  <div class="network_map container-fluid d-flex flex-column justify-content-center pl-2 pr-2">

    <!-- voice line -->
    <!-- voice line -->
    <div v-if="mVoiceState.state[0]" class="d-flex flex-row network_obj_row pl-3 pr-3">
      <div class="network_obj d-flex flex-column justify-content-end">
        <div class="customer_end phone">
          <img alt="phone" src="@/assets/images/old-phone.svg">
          <b-icon
              class="state"
              :class="{
            'active': mVoiceState.state[1],
            'warning': !mVoiceState.state[1]}"
              v-bind:icon="mVoiceState.state[1] ? 'check-circle-fill' : 'exclamation-circle-fill'">
          </b-icon>
        </div>
      </div>
      <div class="network_placeholder">
      </div>
    </div>
    <!-- voice line description -->
    <div v-if="mVoiceState.state[0]" class="d-flex flex-row network_description_row top">

      <div class="network_obj description">
        <div class="d-flex flex-row justify-content-center">
          <label style="font-weight: bold">{{mVoiceState.value[0].label}}</label>
          <div>{{mVoiceState.value[0].value}}</div>
        </div>
      </div>
      <div class="network_link customer_end"></div>

      <div class="network_obj description sm">
      </div>
      <div class="network_link"></div>

      <div class="network_obj description">
      </div>
      <div class="network_link"></div>

      <div class="network_obj description">
      </div>
    </div>

    <!-- main line -->
    <!-- main line -->
    <div class="d-flex flex-row network_obj_row pl-3 pr-3">

      <!-- router -->
      <div class="network_obj d-flex flex-column justify-content-end">
        <div class="customer_end router">
          <img alt="router" src="@/assets/images/router.svg">
          <b-icon
              class="state"
              :class="{
            'active': mRouterState.state,
            'warning': !mRouterState.state}"
            v-bind:icon="mRouterState.state ? 'check-circle-fill' : 'exclamation-circle-fill'">
          </b-icon>
        </div>
      </div>
      <div class="network_link customer_end d-flex flex-column justify-content-end">
        <div class="link"></div>
      </div>

      <!-- ONT -->
      <div class="network_obj d-flex flex-column justify-content-end">
        <div class="customer_end">
          <img alt="ont" src="@/assets/images/osa_hub.svg">
          <b-icon
              class="state"
              :class="{
            'active': mOntState.state,
            'warning': !mOntState.state}"
              v-bind:icon="mOntState.state ? 'check-circle-fill' : 'exclamation-circle-fill'">
          </b-icon>
        </div>
      </div>
      <div class="network_link d-flex flex-column justify-content-end">
        <div class="link"></div>
      </div>

      <!-- OLT-->
      <div class="network_obj">
        <img alt="olt" src="@/assets/images/osa_hub.svg">
        <b-icon
            class="state"
            :class="{
            'active': mOltState.state,
            'warning': !mOltState.state}"
            v-bind:icon="mOltState.state ? 'check-circle-fill' : 'exclamation-circle-fill'">
        </b-icon>
      </div>
      <div class="network_link d-flex flex-column justify-content-end">
        <div class="link"></div>
      </div>

      <!-- cloud -->
      <div class="network_obj">
        <img alt="cloud" src="@/assets/images/osa_cloud.svg">
        <b-icon
            class="state"
            :class="{
            'active': mInternetState.state[0] && !mInternetState.state[1],
            'restricted': mInternetState.state[0] && mInternetState.state[1],
            'warning': !mInternetState.state[0]}"
            v-bind:icon="mInternetState.state[0] ? 'check-circle-fill' : 'exclamation-circle-fill'">
        </b-icon>
      </div>
    </div>

    <!-- main line description -->
    <div class="d-flex flex-row network_description_row">
      <!-- Router -->
      <div class="network_obj description">
        <div class="d-flex flex-row justify-content-center" v-for="value in mRouterState.value"
             v-bind:key="value.key">
          <label style="font-weight: bold">{{value.label}}</label>
          <div>{{value.value}}</div>
        </div>
      </div>
      <div class="network_link customer_end"></div>

      <!-- ONT -->
      <div class="network_obj description sm">
        <div class="d-flex flex-row justify-content-between" v-for="value in mOntState.value"
             v-bind:key="value.key">
          <label style="font-weight: bold">{{value.label}}</label>
          <div>{{value.value}}</div>
        </div>
      </div>
      <div class="network_link"></div>

      <!-- OLT-->
      <div class="network_obj description">
        <div class="d-flex flex-row justify-content-center" v-for="value in mOltState.value"
             v-bind:key="value.key">
          <label style="font-weight: bold">{{value.label}}</label>
          <div>{{value.value}}</div>
        </div>
      </div>
      <div class="network_link"></div>

      <!-- cloud -->
      <div class="network_obj description">
        <div class="d-flex flex-row justify-content-between" v-for="value in mInternetState.value"
             v-bind:key="value.key">
          <label style="font-weight: bold">{{value.label}}</label>
          <div>{{value.value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logger from "@/util/logger";

const LOG_TAG = 'network_map';

export default {
  name: LOG_TAG,
  props: {
    _networkState: {
      type: Array,
      default: function () {
        //{text: '', value: '', type: 'help', 'account'}
        return [
          {key: 'router', state: false, value: []},
          {key: 'ont', state: false, value: []},
          {key: 'olt', state: false, value: []},
          {key: 'internet', state: false, value: []},
          {key: 'voice', state: [false, false], value: []},
        ];
      }
    },
  },
  data() {
    return {
      mRouterState: {
        state: false,
        value: [],
      },
      mOntState: {
        state: false,
        value: [],
      },
      mOltState: {
        state: false,
        value: [],
      },
      mInternetState: {
        state: false,
        value: [],
      },
      mVoiceState: {
        state: false,
        value: [],
      }
    };
  },
  mounted() {
    //
    const vm = this;
    const routerState = vm._networkState.find((state) => state.key === 'router');
    if (routerState) {
      vm.mRouterState = {
        state: routerState.state,
        value: routerState.value,
      };
    }
    const ontState = vm._networkState.find((state) => state.key === 'ont');
    if (ontState) {
      vm.mOntState = {
        state: ontState.state,
        value: ontState.value,
      };
    }
    const oltState = vm._networkState.find((state) => state.key === 'olt');
    if (oltState) {
      vm.mOltState = {
        state: oltState.state,
        value: oltState.value,
      };
    }
    const internetState = vm._networkState.find((state) => state.key === 'internet');
    if (internetState) {
      vm.mInternetState = {
        state: internetState.state,
        value: internetState.value,
      };
    }
    const voiceState = vm._networkState.find((state) => state.key === 'voice');
    if (voiceState) {
      vm.mVoiceState = {
        state: voiceState.state,
        value: voiceState.value,
      };
    }
    logger.d(LOG_TAG, 'mounted', vm.mRouterState);
  }
}
</script>

<style scoped>
.network_map {
  position: relative;
  min-height: 18rem
}
.network_link,
.network_placeholder {
  flex: 1;
  height: 100%;
}
.network_link .link {
  width: 100%;
  height: 1px;
  margin-bottom: 2rem;
  background-color: black;
}
.network_link.customer_end {
  flex: 0.6;
}
.network_obj_row {
  width: 100%;
  height: 6rem;
}
.network_obj {
  position: relative;
  flex: 0 0 6rem;
  height: 100%;
}
.network_obj .customer_end {
  position: relative;
  width: 65%;
  height: 65%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.3rem;
}
.network_obj .customer_end.phone {
  width: 60%;
  height: 60%;
}
.network_obj .customer_end.router {
  width: 90%;
  height: 90%;
  margin-bottom: 0rem;
}
.network_obj img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.network_obj .state {
  position: absolute;
  width: 1.0rem;
  height: 1.0rem;
  top: 0.6rem;
  right: 0.6rem;
}
.network_obj .state.active {
  color: mediumseagreen
}
.network_obj .state.restricted {
  color: orange;
}
.network_obj .state.warning {
  color: orangered;
}
.network_obj .customer_end .state {
  top: 0.3rem;
  right: 0.3rem;
}
.network_obj .customer_end.router .state {
  top: 0.6rem;
  right: 0.6rem;
}
.network_obj .customer_end.phone .state {
  top: 0.1rem;
  right: 0.1rem;
}
.network_description_row {
  width: 100%;
  min-height: 6rem;
}
.network_description_row.top {
  min-height: 2rem;
}
.network_obj.description {
  flex: 1 0 8rem;
  font-size: small;
}
.network_obj.description.sm {
  flex: 1 0 5rem;
}
</style>
